"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Logo = require("../Logo.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Pill = function Pill(_ref) {
  var size = _ref.size,
    className = _ref.className,
    fillColor = _ref.fillColor,
    type = _ref.type,
    title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(_Logo.LogoStyled, {
    className: className,
    "data-key": "max-logo",
    size: size,
    logoType: type,
    viewBox: "0 0 171 48.65",
    xmlns: "http://www.w3.org/2000/svg",
    title: title
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M162.73,9.17A16.35,16.35,0,0,0,156,2.39C153.11.83,149.94,0,143.78,0H21.33C15.16,0,12,.83,9.1,2.39A16.21,16.21,0,0,0,2.38,9.17C.83,12.09,0,15.28,0,21.5v5.65c0,6.21.83,9.41,2.38,12.33A16.19,16.19,0,0,0,9.1,46.25c2.89,1.57,6.06,2.4,12.23,2.4H143.78c6.16,0,9.33-.83,12.23-2.4a16.19,16.19,0,0,0,6.72-6.77c1.55-2.92,2.37-6.12,2.37-12.33V21.5C165.1,15.28,164.28,12.09,162.73,9.17Z",
    fill: fillColor
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M167.22.63a3,3,0,0,0-3,3.1v0a3,3,0,1,0,6.07,0A3,3,0,0,0,167.44.63ZM168.32,6l-1.14-1.9h-.75V6h-.65V1.61h1.64c1,0,1.53.38,1.53,1.24a1.13,1.13,0,0,1-1.06,1.2h-.07l1.23,2Z",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m168.26 2.81c0-0.54-0.48-0.64-0.94-0.64h-0.89v1.35h0.78c0.55 0 1.05-0.04 1.05-0.71z",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M167.22,0a3.76,3.76,0,0,0-3.8,3.72v.06a3.79,3.79,0,1,0,7.58,0A3.76,3.76,0,0,0,167.26,0Zm0,7a3,3,0,0,1-3-3V3.83a3,3,0,1,1,6.07,0A3,3,0,0,1,167.47,7Z",
    fill: fillColor
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M169,2.85c0-.86-.51-1.24-1.53-1.24h-1.64V6h.65V4.08h.75L168.32,6h.73l-1.23-1.93A1.13,1.13,0,0,0,169,3Zm-2.52.67V2.17h.89c.46,0,.94.1.94.64s-.5.71-1,.71Z",
    fill: fillColor
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "96.21 8.89 87.53 8.89 87.53 38.31 96.21 38.33",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m102.6 17.38a4.47 4.47 0 0 0 4.46-4.48 4.45 4.45 0 1 0-4.46 4.48z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "98.38 38.33 107.06 38.33 107.07 38.33 107.07 18.71 107.06 18.71 98.38 18.71",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M56.76,38.33c4.33,0,9.46-1.73,10.69-6.26H58.72a1.94,1.94,0,0,1-2.11,1.6,2.26,2.26,0,0,1-1.69-.61,4.13,4.13,0,0,1-.84-3v-.26H68a9.58,9.58,0,0,0-2.67-7.63,12.31,12.31,0,0,0-9.09-3.5A11.53,11.53,0,0,0,48,21.78a9.61,9.61,0,0,0-2.83,7,8.52,8.52,0,0,0,2.52,6.33C49.79,37.2,53,38.33,56.76,38.33ZM54.08,26.1a2.47,2.47,0,0,1,2.15-2.75l.27,0a2.51,2.51,0,0,1,1.75.72,2.87,2.87,0,0,1,.85,2.05v.27h-5Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "111.95 25.69 111.95 25.97 111.95 38.33 121.4 38.33 121.4 25.98 121.4 25.7 121.68 25.7 124.44 25.69 124.42 18.56 121.68 18.56 121.4 18.56 121.4 18.29 121.4 11.08 111.95 11.08 111.95 18.29 111.95 18.56 111.66 18.56 109.24 18.56 109.24 25.69 111.66 25.69",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M78.9,38.33V30.88c0-2.45,1.21-5.08,3.88-5.08h2.57V18.72h0c-3.19-.08-5.57.92-6.55,3.71V18.71H70.16V38.32H78.9Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M44.1,30.93a6.44,6.44,0,0,0-4.64-6.35l-1.19-.39a7.11,7.11,0,0,0,1.2-.33,5.35,5.35,0,0,0,3.38-5.35,6.75,6.75,0,0,0-1.75-4.92c-1.65-1.7-4.46-2.51-8.6-2.51H20.22V38.33H34.44C39.11,38.33,44.1,36.39,44.1,30.93ZM29.91,21.49V17.24h1.21a3.69,3.69,0,0,1,2.73.66,2.14,2.14,0,0,1,.53,1.53A2.16,2.16,0,0,1,33.82,21a3.82,3.82,0,0,1-2.75.74H29.91Zm.26,10.74h-.26V27.09h1.3c1.18,0,2.8,0,3.68.9a2.25,2.25,0,0,1,.61,1.65,2.35,2.35,0,0,1-.62,1.69c-.88.9-2.51.9-3.6.9Z",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    points: "126.61 38.33 145.89 38.33 146.15 38.33 146.15 31.3 145.89 31.29 140.91 31.29 139.21 31.29 138.75 31.29 139 30.86 146.15 18.71 126.61 18.71 126.61 25.77 131.55 25.77 133.27 25.77 133.73 25.77 133.49 26.19",
    fill: "#fff"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.07,21.76A3.82,3.82,0,0,0,33.82,21a2.21,2.21,0,0,0,.56-1.59,2.14,2.14,0,0,0-.53-1.53,3.69,3.69,0,0,0-2.73-.66H29.91v4.52h1.16Z",
    fill: fillColor
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.5,29.64A2.29,2.29,0,0,0,34.89,28c-.88-.9-2.5-.9-3.68-.9h-1.3v5.14h1.37c1.09,0,2.72,0,3.6-.9A2.32,2.32,0,0,0,35.5,29.64Z",
    fill: fillColor
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58.83,26.37h.27V26.1a2.87,2.87,0,0,0-.85-2.05,2.51,2.51,0,0,0-1.75-.72,2.45,2.45,0,0,0-2.42,2.77v.27Z",
    fill: fillColor
  }));
};
var _default = Pill;
exports.default = _default;